// extracted by mini-css-extract-plugin
export default {"coro":"Newstyle_coro__a2cHG"};